import { useMutation } from "react-query";

import httpClient from "utils/http-client";
import { API_FORGOT_PASSWORD_CONFIRM } from "consts";

export default function useForgotPasswordConfirm(config) {
  return useMutation(
    ({ token, password, repeatedPassword }) =>
      httpClient.post(API_FORGOT_PASSWORD_CONFIRM, {
        token,
        newPassword: password,
        confirmPassword: repeatedPassword,
      }),
    config
  );
}
